import * as React from 'react'
import { inject, observer } from 'mobx-react'
// import { toJS } from 'mobx'
import { Row, Col, Input, Icon, Table, Modal } from 'antd'
import { ComponentExt } from 'util/reactExt'
import { taskType } from 'constants/index'
import { withPopconfirm, withPopover } from 'components/HOC/AntdWrapper'
import { SubTabKeys } from 'containers/views/Levelup/ConfigContentModal'
import styles from './index.scss'
const Search = Input.Search
const PER_PAGE = 5
interface IConfigContentLibraryProps {
  levelStore?: any
  currentTab: string
  toggleSubTab?: (key: SubTabKeys) => void
  globalStore?: any
  onRef?: any
}

interface IConfigContentLibraryState {
  currentPage: number
  filter: string
}

@inject('globalStore', 'levelStore')
@observer
export default class ConfigContentLibrary extends ComponentExt<
  IConfigContentLibraryProps,
  IConfigContentLibraryState
> {
  state = {
    currentPage: 1,
    filter: '',
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.currentTab !== SubTabKeys.LIBRARY) {
      return {
        currentPage: 1,
      }
    }

    return null
  }

  async componentDidMount() {}

  getDataList = async (param?): Promise<any> => {
    const { filter } = this.state

    const {
      levelStore: { getConfigContentList },
    } = this.props

    getConfigContentList(param, this.isVideo ? 'video' : 'example')
  }

  onSearch = title => {
    this.setState({ filter: title })
    this.getDataList(this.handleDifferentQS({ filter: title, pageindex: 1 }))
  }

  // 后端分页查询字段不一致因此需要前端恶心处理😒
  handleDifferentQS = (param: {
    filter?: string
    pageindex?: number
    pageSize?: number
  }) => {
    let payload = {}
    if (this.isVideo) {
      payload = {
        title: param.filter,
        pageindex: param.pageindex || 1,
        pagesize: param.pageSize || 5,
      }
    } else {
      payload = {
        keyword: param.filter,
        per_page: param.pageSize,
        page: param.pageindex,
      }
    }
    return payload
  }

  filterChange = e => {
    this.setState({ filter: e.target.value })
  }

  onPressEnter = e => {
    const title = e.target.value
    this.setState({ filter: title })
    this.getDataList(this.handleDifferentQS({ filter: title }))
  }

  goToEditZone = () => {
    this.props.toggleSubTab(SubTabKeys.EDIT_ZONE)
  }

  editConfigContent = (currentConfigContent: any): void => {
    const {
      levelStore: { setCurrentConfigContent },
    } = this.props
    setCurrentConfigContent(currentConfigContent)
    this.goToEditZone()
  }

  deleteConfigContent = async id => {
    const {
      levelStore: {
        configContentMeta: { total },
        currentConfigContentType,
      },
    } = this.props
    const { filter, currentPage } = this.state
    let pageindex = 1

    if (currentConfigContentType === taskType.video) {
      await this.api.level.deleteAdvancedVideo(id)
    } else {
      await this.api.level.deleteAdvancedExample(id)
    }

    this.$message.info(`${currentConfigContentType}删除成功。`)

    if ((total - 1) % PER_PAGE === 0) {
      pageindex = currentPage - 1
    } else {
      pageindex = currentPage
    }

    this.setState({ currentPage: pageindex })
    this.getDataList(
      this.handleDifferentQS({
        filter,
        pageindex,
      }),
    )
  }

  get isVideo() {
    const {
      levelStore: { currentConfigContentType },
    } = this.props
    return currentConfigContentType === taskType.video
  }

  render() {
    const {
      levelStore: {
        currentConfigContentType,
        configContentList,
        configContentMeta,
      },
      globalStore: { staffInfo },
    } = this.props
    const { currentPage, filter } = this.state
    const typeTxt =
      currentConfigContentType === taskType.example ? '题目' : '视频'
    const columns = [
      {
        title: '序号',
        dataIndex: 'order',
        key: 'order',
        render: (text, record, index) => index + 1,
      },
      {
        title: this.isVideo ? '标题' : '题目',
        key: 'title',
        render: (text, record) => {
          const txt = this.isVideo ? (
            <a
              target="_blank"
              href={`/#/course/${record.id}/?type=${record.type}`}
            >
              {record.title}
            </a>
          ) : (
            record.content
          )
          return withPopover({
            content: txt,
            placement: 'bottom',
          })(<div className={styles.ellipsisTitle}>{txt}</div>)
        },
      },
      {
        title: this.isVideo ? '简介' : '答案',
        key: 'article_desc',
        render: (text, record) => {
          const txt = this.isVideo
            ? record.article_desc
            : record.answers && record.answers[0]
          return withPopover({
            content: <div dangerouslySetInnerHTML={{ __html: txt }} />,
            overlayStyle: { width: 300 },
            placement: 'bottom',
          })(
            <div
              className={styles.ellipsisDesc}
              dangerouslySetInnerHTML={{ __html: txt }}
            />,
          )
        },
      },
      {
        title: '操作',
        key: 'operation',
        render: (text, record, index) => {
          return (
            (this.isVideo
              ? record.creator_id === staffInfo.staff_id
              : true) && (
              <div>
                {
                  <a
                    style={{ paddingRight: 6 }}
                    onClick={this.editConfigContent.bind(this, record)}
                  >
                    <Icon type="form" />
                  </a>
                }
                {withPopconfirm({
                  title: `确定删除当前${typeTxt}吗？`,
                  onConfirm: this.deleteConfigContent.bind(this, record.id),
                })(
                  <a>
                    <Icon type="delete" />
                  </a>,
                )}
              </div>
            )
          )
        },
      },
    ]

    const paginationConfig = {
      pageSize: PER_PAGE,
      total: configContentMeta && configContentMeta.total,
      current: currentPage,
      onChange: (page, pageSize) => {
        this.setState({ currentPage: page })
        this.getDataList(
          this.handleDifferentQS({
            filter,
            pageindex: page,
            pageSize,
          }),
        )
      },
    }

    return (
      <div className={'styles.configContentLibrary'}>
        <Row>
          <Col span={2} style={{ textAlign: 'right' }}>
            {`${typeTxt}库：`}
          </Col>
          <Col span={22}>
            <Search
              onChange={this.filterChange}
              placeholder={'请输入关键词查找'}
              enterButton
              onSearch={this.onSearch}
              onPressEnter={this.onPressEnter}
            />
            <Table
              rowKey={'id'}
              pagination={paginationConfig}
              dataSource={configContentList}
              columns={columns}
            />
          </Col>
        </Row>
      </div>
    )
  }
}
